import Fitting from '@/models/Fitting';

export default class CreateFittingIfNotExists
{
    /**
     * Vue Object
     */
    v = null;

    /**
     * "right" or "left"
     * @string
     */
    side = null;

    constructor(v, side)
    {
        this.v = v;
        this.side = side;
    }

    async handle()
    {
        const lensOrderUrlManager = this.v.lensOrderUrlManager;
        const side = this.side;

        // If the URL has no reference, SN or prototype code on the given side,
        // reset that side.
        if(lensOrderUrlManager.hasPrototypeCode(side))
        {
            const fitting = this.v.$store.getters['lensOrder/getFitting'](side);

            // If there is no fitting object for this side, create one.
            if(!fitting)
            {
                // Mutation
                this.v.$store.commit('lensOrder/setFitting', {
                    side:    side,
                    fitting: new Fitting(this.v.$store),
                });

                console.log(`Fitting instance was created on ${side} side.`);
            }
        }

        return true;
    }
}
